export default __webpack_public_path__ + "static/media/ill-no-class.5ffed1a3.svg";